import { SET_SERVER } from '../types';

export const setServer = (data) => (dispatch) => {
    dispatch({
        type: SET_SERVER,
        payload: data,
    });
};
